import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=0fd73d5e&scoped=true&"
import script from "./authLayout.vue?vue&type=script&lang=js&"
export * from "./authLayout.vue?vue&type=script&lang=js&"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=0fd73d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd73d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VSheet,VSnackbar})
